import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import AcademicCalendarService from "../../Services/AcademicCalendar.service";
import FacultyCourseListWidget from "../Presentational/Widgets/FacultyCourseListWidget";
import useService from "../Hooks/useService";
const FacultyCourseListContainer = () => {
    const [currentTerm, setCurrentTerm] = React.useState({
        id: "",
        name: "",
    });
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [coursesState, loadCourses] = useService(AcademicCalendarService.getFacultyCourses);
    const refresh = React.useCallback(() => {
        loadCourses(currentTerm.id);
    }, [currentTerm.id, loadCourses]);
    React.useEffect(() => {
        if (currentTerm.id === "") {
            AcademicCalendarService.getClosestTermForFaculty().then((response) => setCurrentTerm({ id: response.id, name: response.name }));
        }
        refresh();
    }, [currentTerm.id, refresh]);
    return (_jsx(FacultyCourseListWidget, { courseState: coursesState, currentTerm: currentTerm, refresh: refresh, changeTerm: setCurrentTerm, isModalOpen: isModalOpen, setIsModalOpen: setIsModalOpen }));
};
export default FacultyCourseListContainer;
